/**
 * HEADER_PINNED_SCROLL_Y_BREAKPOINT
 * A portion of our header will scroll, once it gets hits the HEADER_PINNED_SCROLL_Y_BREAKPOINT breakpoint,
 * the header stops scrolling
 *
 * Why 60 pixels?
 *  - Row1: height: 40px + Header padding-top 18px = 58px
 *  - Row2: margin-top 12px when not scrolled, 10px when scrolled
 *      12-10 = 2
 *      Note: I chose to scroll 2 more pixels, rather than removing 2px margin-top
 *  - 58px + 2px = 60px
 *
 *  headerScrollYRange 1:1 with 60px distance the header will scroll offset to the window scrolling range
 *      the header will always travel 60px, on default pages this starts at scrollY 0 and ends at scrolly 60
 *      on Hero pages it is based on when the inline searchBar dissapears, so not scrollY 0
 *      for example: Home starts at scrollY 300 and ends at scrolly 360. Still 60px travelled
 *      but offset to the window scroll range
 *  row2Animate: the scrollY breakpoint to animate into and out of isCompact
 */
export const HEADER_PINNED_SCROLL_Y_BREAKPOINT = 60;

/**
 * getHeroPageScrollY calculate headerScrollYRange and row2Animate
 * @param {Number} headerScrollYStart
 * @param {Number} row2Animate
 * @returns {Object}
 */
const getHeroPageScrollY = (headerScrollYStart, row2Animate) => {
    return {
        headerScrollYRange: {
            start: headerScrollYStart,
            end: headerScrollYStart + HEADER_PINNED_SCROLL_Y_BREAKPOINT
        },
        row2Animate
    };
};

export const SCROLL_Y_HOME = 300;
export const SCROLL_Y_ICONS = 433;
export const SCROLL_Y_PHOTOS = 433;

export const SCROLL_Y_BREAKPOINTS = {
    default: getHeroPageScrollY(0, HEADER_PINNED_SCROLL_Y_BREAKPOINT),
    home: getHeroPageScrollY(
        SCROLL_Y_HOME,
        SCROLL_Y_HOME + HEADER_PINNED_SCROLL_Y_BREAKPOINT
    ),
    icons: getHeroPageScrollY(
        SCROLL_Y_HOME,
        SCROLL_Y_ICONS + HEADER_PINNED_SCROLL_Y_BREAKPOINT
    ),
    photos: getHeroPageScrollY(
        SCROLL_Y_HOME,
        SCROLL_Y_PHOTOS + HEADER_PINNED_SCROLL_Y_BREAKPOINT
    )
};

export const HEADER_HEIGHT_MAX = 128;
export const HEADER_HEIGHT_MIN = HEADER_PINNED_SCROLL_Y_BREAKPOINT;
